import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { SITE } from "../mock";

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  const message = encodeURIComponent(
    "Hi Casa Elio! I'm interested in booking a stay at the villa in San Juan del Sur. Could you share availability and rates?"
  );
  const link = `https://wa.me/${SITE.whatsappRaw}?text=${message}`;

  return (
    <div
      className={`fixed right-5 bottom-5 md:right-7 md:bottom-7 z-50 transition-all duration-700 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      {open && (
        <div className="mb-3 w-[280px] bg-white shadow-2xl rounded-sm border border-[#e3dac6] overflow-hidden animate-[fadeIn_.4s_ease]">
          <div className="bg-[#2f4438] text-[#f5f0e6] px-4 py-3 flex items-center justify-between">
            <div>
              <div className="font-serif-display text-lg leading-none">Casa Elio</div>
              <div className="text-[10px] uppercase tracking-[0.2em] opacity-80 mt-1">Typically replies within an hour</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="opacity-80 hover:opacity-100"
              aria-label="Close chat"
            >
              <X size={16} />
            </button>
          </div>
          <div className="p-4 text-sm text-[#1f2a24]">
            <p className="mb-3 leading-relaxed">
              Hello — chat directly with our host on WhatsApp. We'll help you plan dates, suites, and the slow side of the coast.
            </p>
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="block w-full text-center bg-[#25D366] hover:bg-[#1ebe5a] text-white text-[11px] uppercase tracking-[0.25em] px-4 py-3 transition-colors"
            >
              Start chat · {SITE.whatsapp}
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((s) => !s)}
        className="group relative h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-105"
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
        <MessageCircle className="relative text-white" size={26} />
      </button>
    </div>
  );
};

export default WhatsAppFloat;
